import { COLUMN_DEVICE, COLUMN_NAME, COLUMN_TYPE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const DeviceActionColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "setting.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        sortByName: "setting.settingType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type"
    },
    {
        heading: "Device",
        accessor: "device",
        isNumeric: false,
        id: 2,
        sortByName: "deviceImprox.devName",
        sortDirection: "asc",
        active: true,
        translationKey: "device"
    }
];

export default DeviceActionColumns;
